import type { DocumentStyleGroup } from '@dealstack/frontend/shared/components/EmailTemplates/components/inspector/GlobalProperties.types';

export const PADDING_SIDES = ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];
export const MARGIN_SIDES = ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'];

// The shared email frame: its styles live in the layout shell the save strips,
// so they would be controls that change nothing in a sent email.
const FRAME_REFERENCES = ['body', 'container'];
const HIDDEN_GROUP_TITLES = ['Code Block', 'Inline Code'];
const HIDDEN_PROPS = ['fontFamily', 'letterSpacing', 'height'];

const isFrameGroup = (group: DocumentStyleGroup): boolean =>
	FRAME_REFERENCES.includes(String(group.classReference ?? '')) ||
	group.inputs.every((input) => FRAME_REFERENCES.includes(String(input.classReference ?? '')));

export const visibleDocumentGroups = (groups: DocumentStyleGroup[]): DocumentStyleGroup[] =>
	groups.filter(
		(group) =>
			!HIDDEN_GROUP_TITLES.includes(group.title) &&
			group.inputs.length > 0 &&
			!isFrameGroup(group)
	);

export const sideFamilyFor = (prop: string): string[] | undefined => {
	if (PADDING_SIDES.includes(prop)) {
		return PADDING_SIDES;
	}
	if (MARGIN_SIDES.includes(prop)) {
		return MARGIN_SIDES;
	}
	return undefined;
};

export const isHiddenDocumentInput = (prop: string, siblingProps: string[]): boolean =>
	HIDDEN_PROPS.includes(prop) ||
	(prop === 'borderColor' && !siblingProps.includes('borderWidth'));

const RENAMED_LABELS: Record<string, string> = { Paragraph: 'Text' };

export const humanizeStyleLabel = (label: string): string =>
	RENAMED_LABELS[label] ??
	label
		.replace(
			/([a-z0-9])([A-Z])/g,
			(_match, before: string, after: string) => `${before} ${after.toLowerCase()}`
		)
		.replace(/^./, (character) => character.toUpperCase());
